import { Helmet } from "react-helmet-async";

const OrganizationSchema = () => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "hopeflymeta",
          "url": "https://www.hopeflymeta.com",
          "sameAs": []
        }
        `}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;
